module.exports = __webpack_public_path__ + "img/e-step_300_trasparente.58e0c05c.png";